import moment from 'moment';
import { Box, IconButton, TextField, Button } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Delete } from '@mui/icons-material';

const WorkdayHoursArray = (props) => {
  const { formData = [], onChange, errorSchema } = props;

  const addNewItem = () => {
    const newItem = { date: undefined, open: undefined, close: undefined, name: undefined };
    onChange([...formData, newItem]);
  };

  const removeItem = (index) => {
    const updatedArray = formData.filter((_, idx) => idx !== index);
    onChange(updatedArray);
  };

  const handleFieldChange = (index, key, value) => {
    const updatedArray = formData.map((item, idx) =>
      idx === index ? { ...item, [key]: value } : item
    );

    onChange(updatedArray);
  };

  const parseTimeString = (timeString) => {
    if (typeof timeString !== 'string' || !timeString) return null;
    const [hours, minutes] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
  };

  const formatTimeString = (date) => {
    if (!(date instanceof Date) || date.getTime().isNaN) return null;
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const getFieldError = (fieldIndex, fieldKey) => {
    if (!errorSchema) return null;

    const fieldError =
      errorSchema[fieldIndex] && errorSchema[fieldIndex][fieldKey]
        ? errorSchema[fieldIndex][fieldKey]
        : null;

    return fieldError && fieldError.__errors ? fieldError.__errors[0] : null;
  };

  const formatDate = (date) => {
    if (!date) return undefined;
    return moment(date).format('YYYY-MM-DD');
  };

  const handleDateChange = (index, newValue) => {
    const formattedDate = newValue ? formatDate(newValue) : undefined;
    handleFieldChange(index, 'date', formattedDate);
  };

  return (
    <Box className="flex flex-col gap-20">
      {formData.map((item, index) => {
        return (
          <Box key={index} className="flex gap-4 items-center">
            <Box>
              <TextField
                label="Name"
                multiline
                value={item.name}
                helperText={getFieldError(index, 'name') ? 'Invalid name' : ''}
                error={!!getFieldError(index, 'name')}
                onChange={(e) => handleFieldChange(index, 'name', e.target.value || undefined)}
                className="mb-16 w-full"
              />
              <Box className="flex items-center gap-4">
                <DatePicker
                  label="Date"
                  value={item.date ? new Date(item.date) : null}
                  slotProps={{
                    textField: {
                      helperText: getFieldError(index, 'date') ? 'Invalid date' : '',
                      error: !!getFieldError(index, 'date'),
                    },
                  }}
                  format="yyyy-MM-dd"
                  onChange={(newValue) => handleDateChange(index, newValue)}
                />
                <TimePicker
                  label="Start Time"
                  value={parseTimeString(item.open)}
                  localeText={{
                    fieldHoursPlaceholder: () => '--',
                    fieldMinutesPlaceholder: () => '--',
                    fieldMeridiemPlaceholder: () => 'AM/PM',
                  }}
                  slotProps={{
                    textField: {
                      helperText: getFieldError(index, 'open') ? 'Invalid time' : '',
                      error: !!getFieldError(index, 'open'),
                    },
                  }}
                  onChange={(newValue) =>
                    handleFieldChange(
                      index,
                      'open',
                      newValue ? formatTimeString(newValue) : undefined
                    )
                  }
                />
                <TimePicker
                  label="End Time"
                  value={parseTimeString(item.close)}
                  localeText={{
                    fieldHoursPlaceholder: () => '--',
                    fieldMinutesPlaceholder: () => '--',
                    fieldMeridiemPlaceholder: () => 'AM/PM',
                  }}
                  slotProps={{
                    textField: {
                      helperText: getFieldError(index, 'close') ? 'Invalid time' : '',
                      error: !!getFieldError(index, 'close'),
                    },
                  }}
                  onChange={(newValue) =>
                    handleFieldChange(
                      index,
                      'close',
                      newValue ? formatTimeString(newValue) : undefined
                    )
                  }
                />
              </Box>
            </Box>
            <IconButton color="error" onClick={() => removeItem(index)}>
              <Delete />
            </IconButton>
          </Box>
        );
      })}
      <Button
        onClick={addNewItem}
        sx={{
          color: 'black',
          opacity: 0.89,
          border: '1px solid rgba(224, 226, 232, 1)',
          borderRadius: '4px',
          padding: '8px 16px',
          fontSize: '14px',
          fontWeight: 600,
        }}
      >
        Add date
      </Button>
    </Box>
  );
};

export default WorkdayHoursArray;
